import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { MuiThemeProvider, createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import storeConfig from './redux/store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto-condensed/300.css';
import '@fontsource/roboto-condensed/400.css';
import '@fontsource/roboto-condensed/500.css';
import '@fontsource/roboto-condensed/700.css';
import 'normalize.css';
import './styles/index.css';
import packageJson from '../package.json';

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const theme = responsiveFontSizes(
  createMuiTheme({
    palette: {
      primary: {
        main: '#FF6720',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#6c757d',
      },
    },
    typography: {
      fontFamily: ['Roboto', 'sans-serif', '-apple-system'].join(','),
      body1: {
        lineHeight: 1.3,
      },
      body2: {
        lineHeight: 1.3,
      },
    },
    overrides: {
      MuiInput: {
        underline: {
          '&&:hover:before': {
            borderBottom: '1px solid #ced4da',
          },
          '&:after': {
            borderBottom: '1px solid #6c757d',
          },
          '&:before': {
            borderBottom: '1px solid #ced4da',
          },
        },
      },
      MuiButtonBase: {
        root: {
          '&:focus': {
            outline: 'none',
          },
          '&.Mui-focusVisible': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(179, 71, 23, 0.5) !important',
          },
        },
      },
      MuiButton: {
        root: {
          fontSize: '1rem',
          borderRadius: 8,
          textTransform: 'none',
          '&:focus': {
            outline: 'none',
          },
          '&.Mui-focusVisible': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(179, 71, 23, 0.5)',
          },
          /* disabled styles */
          '&.Mui-disabled': {
            color: '#6F7A83 !important',
            backgroundColor: '#E6E9EA !important',
          },
        },
        outlinedPrimary: {
          '&:focus': {
            outline: 'none',
          },
          '&.Mui-focusVisible': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(179, 71, 23, 0.5)',
          },
        },
      },
      MuiIconButton: {
        root: {
          '&:focus': {
            outline: 'none',
          },
          '&.Mui-focusVisible': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(179, 71, 23, 0.5)',
          },
        },
      },
      MuiFormLabel: {
        root: {
          '&.Mui-focused': {
            color: 'inherit !important',
          },
        },
      },
    },
  })
);
// eslint-disable-next-line no-console
console.log(` ${packageJson.name} - Version: ${packageJson.version}`);

ReactDOM.render(
  <Provider store={storeConfig.store}>
    <MuiThemeProvider theme={theme}>
      <PersistGate loading={null} persistor={storeConfig.persistor}>
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY} language="es-419">
          <BrowserRouter basename={process.env.REACT_APP_BASENAME || '/tescucha'}>
            <App />
          </BrowserRouter>
        </GoogleReCaptchaProvider>
      </PersistGate>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
